<template>
  <div :style="{'height': windowHeight + 'px'}" class="lamp-notif-sized-container-for-mobile">
    <div class="row ml-3 lamp-notif-container-mobile">
      <div class="nav sidebar-list flex-column col-10 col-sm-6 col-md-5">
        <template v-for="item in links">
          <template v-if="item.isMainButton">
            <b-button class="sidebar-create-annonce-btn" :class="activeItem(item)" variant="primary" @click="itemClicked(item)">
              <b-nav-item :class="'sidebar-link-btn'">
                  <div>{{ item.title }}</div>
              </b-nav-item>
            </b-button>
          </template>
          <template v-else-if="!item.isLogout && activeItem(item)">
            <b-nav-item :class="'sidebar-link ' + activeItem(item) + (item.isRed ? ' sidebar-link-red' : '') + ' ' + item.customClass" disabled v-b-toggle.sidebar-mobile>
              <i :class="item.icon + ' mr-3 ph-xl ph-bold ' + activeItem(item)"></i>
              <div :class="activeItem(item)" style="text-align: left;">{{ item.title }}</div>
            </b-nav-item>
          </template>
          <template v-else>
            <b-nav-item :class="'sidebar-link ' + (item.isRed ? ' sidebar-link-red' : '') + ' ' + item.customClass" @click="item.isLogout ? logout() : itemClicked(item)">
              <i :class="item.icon + ' mr-3 ph-xl ph-bold '"></i>
              <div style="text-align: left;">{{ item.title }}</div>
            </b-nav-item>
          </template>
        </template>
      </div>
    </div>
  </div>
</template>

<script>

import {eventBus} from "../../main"

export default {

  name: 'SideMenu',

  props: {
    windowHeight: null,
    links: {type: Array},
  },

  emits:[
    'clickAction'
  ],

  computed: {
    activeItem () {
      let domaineActive = this.$route.path.split('/')[1]
      let actionActive = this.$route.path.split('/')[2]
      return item => item.routesActiveItem ? item.routesActiveItem.filter(routeActiveItem => {
        let domaineRoute = routeActiveItem.split('/')[1]
        let actionRoute = routeActiveItem.split('/')[2]
        return domaineRoute === domaineActive && actionActive === actionRoute
      }).length > 0 ? 'activeItem' : '' : ''
    },
    activeUnderItem () {
      let path = this.$route.path.split('/')
      let subPath = ''
      path.forEach((elem, index) => {
        subPath += (index !== (path.length - 1) && index !== 0) ? '/' + elem : ''
      })
      let subDomain = Number(path[path.length - 1]) ? subPath : this.$route.path
      return underItem => underItem.routesActiveItem ? underItem.routesActiveItem.includes(subDomain) ? 'activeUnderItem' : 'inactiveUnderItem' : 'inactiveUnderItem'
    }
  },

  methods: {

    async logout() {
      await this.$store.dispatch('LogOut')
      await this.$router.push('/login')
    },

    resetFiltersValues() {
      eventBus.$emit("resetFiltersValues")
    },

    itemClicked(item) {
      //au lieu de :to dans b-nav-item car le :to est prioritaire au @click: si on utilise le :to, @click n'est pas exécuté !
      // if(this.$router.currentRoute.path !== route){
      //   this.$router.push(route)
      // }

      this.$emit('clickAction', item.onClickAction)

      //car v-b-toggle.sidebar-mobile ne fonctionne pas si le lien devient active, v-b-toggle n'est plus sur l'élément et n'a pas eu le temps de s'appliquer
      this.$root.$emit('bv::toggle::collapse', 'sidebar-mobile')

      this.resetFiltersValues()
    },

  }
}

</script>

<style scoped>

.lamp-notif-sized-container-for-mobile {
  display: block;
}
.lamp-notif-container-mobile {
  /* hauteur de la window - pt de sidebar-notifs - pt de sidebar-mobile-close-container - height sidebar-mobile-close-icon */
  height: calc(100% - 20px - 20px - 32px);
  overflow-y: auto;
}

.sidebar-create-annonce-btn {
  width: 87%;
  font-size: var(--menu-font-size);
  margin: 12px 22px;
}

@media (max-width: 690px) {
  .sidebar-create-annonce-btn {
    width: 100%;
  }
}

/* Onglet général */
.sidebar-link a {
  color: var(--main-text-color);
  font-size: var(--menu-font-size);
  display: flex;
  align-items: center;
  padding: 12px 22px;
  text-align: left;
  font-family: "KumbhSans-Regular", "Arial", sans-serif;
  line-height: 26px;
}
.sidebar-link-btn a {
  font-size: var(--menu-font-size);
  padding: 0px;
}
.sidebar-link-red a {
  color: var(--main-red-medium);
}

.btn-primary a {
  color: var(--main-black-darker);
}
.btn-primary:hover:not([disabled]) a {
  color: var(--main-black-darker) !important;
}
.btn-primary:focus a, .btn-primary:active a {
  color: var(--main-black-darker) !important;
}

/* Hover d'un onglet */
.sidebar-link a:hover {
  color: var(--main-yellow-medium)
}
.sidebar-link-red a:hover {
  color: var(--main-red-darker)
}

/* Onglet actif */
.activeItem {
  color: var(--main-yellow-medium);
}

/* Bouton 'actif' : .btn-outline-primary */
.sidebar-create-annonce-btn.activeItem {
  display: none;
}

</style>



// WEBPACK FOOTER //
// src/views/menus/SideMenu.vue